(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-featured-collections-new-static-sliders"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const track = document.getElementById('carouselTrack');
  const nextBtn = document.getElementById('nextBtn');
  const prevBtn = document.getElementById('prevBtn');

  const cards = Array.from(track.children);
  cards.forEach(card => {
    const clone = card.cloneNode(true);
    track.appendChild(clone);
  });
const getCardWidth = () => track.firstElementChild.offsetWidth + 15;
  nextBtn.addEventListener('click', () => {
    const cardWidth = getCardWidth();
    const maxScroll = track.scrollWidth - track.offsetWidth;
   if (track.scrollLeft >= (track.scrollWidth / 2) - 10) {
      track.scrollTo({ left: 0, behavior: 'auto' }); 
      setTimeout(() => {
        track.scrollBy({ left: cardWidth, behavior: 'smooth' });
      }, 10);
    } else {
      track.scrollBy({ left: cardWidth, behavior: 'smooth' });
    }
  });
 prevBtn.addEventListener('click', () => {
    const cardWidth = getCardWidth();
  if (track.scrollLeft <= 5) {
      track.scrollTo({ left: track.scrollWidth / 2, behavior: 'auto' });
      setTimeout(() => {
        track.scrollBy({ left: -cardWidth, behavior: 'smooth' });
      }, 10);
    } else {
      track.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fast-shiping-one-liner-text-btn"] && !Shopify.designMode) return;
  try {
    const btnShipFrm = document.getElementsByClassName("btn-frm-group");
const btnTypeAddToCart = document.getElementsByClassName("cv--atc");
const mobileQuery = window.matchMedia('(max-width:767px)');
if (btnShipFrm.length > 0) {
  btnShipFrm[0].style.display = "block";
  function handleTabletChange(e) {
  if (e.matches) {
     btnTypeAddToCart[0].style.width = "77.5%";
  } else {
    btnTypeAddToCart[0].style.width = "79.5%"; 
  }
}
mobileQuery.addEventListener('change', handleTabletChange);
handleTabletChange(mobileQuery);
}
  } catch(e) { console.error(e); }
})();

})();
